import React, { Component } from 'react'
import I18n  from 'i18n'
import RecipeSchemaLink from 'components/RecipeSchemaLink'
import './style.css'


export default class ItemsCreationForm extends Component {
    constructor(props) {
        super(props)

        this.intialState = {
            name: ''
        }

        this.state = {
            ...this.intialState
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()

        if (!this.state.name) {
            return
        }

        this.props.createItem(this.state)
        this.setState({
            ...this.intialState
        })

        this.props.setItemsCreationFormIsEmpty(true)
    }

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        })

        this.props.setItemsCreationFormIsEmpty(e.target.value === '')
    }

    handleInputState = (isFocused) => {
        this.props.setItemsCreationFormIsFocused(isFocused)
    }

    render() {
        return (
            <form className='form form_type_item-creation'>
                <div className='form__input-wrapper'>
                    <input
                        className='form__input'
                        type='text'
                        name='name'
                        value={this.state.name}
                        placeholder={I18n.t('addAnotherItem')}
                        onChange={this.handleChange}
                        onFocus={() => this.handleInputState(true)}
                        onBlur={() => this.handleInputState(false)}
                    />

                    <button
                        className='form__button'
                        type='submit'
                        onClick={this.handleSubmit}>

                        <span className='icon icon-add'></span>
                    </button>
                </div>

                <RecipeSchemaLink />
            </form>
        )
    }
}
